import { createSlice } from "@reduxjs/toolkit"
import { DASHBOARD_CARD_TYPES, DASHBOARD_TABLE_FILTER_TYPES, TABLE_GAME_STATUS_FILTER } from "../utilities/constants"

const initialCardStates = {
  [DASHBOARD_CARD_TYPES.OVERALL_PERFORMANCE]: {
    // visibility: true,
    showPeerChart: true,
  },
  [DASHBOARD_CARD_TYPES.HISTORICAL_PERFORMANCE]: {
    visibility: true,
  },
  [DASHBOARD_CARD_TYPES.GAME_STATUS]: {
    filters: {
      [DASHBOARD_TABLE_FILTER_TYPES.FILTER_GAME_STATUS]: TABLE_GAME_STATUS_FILTER.ALL,
      [DASHBOARD_TABLE_FILTER_TYPES.FILTER_GAME_STATUS_TABLE_COUNT]: `ALL`,
    },
    visibility: true,
  },
  [DASHBOARD_CARD_TYPES.INDIVIDUAL_PERFORMANCE]: {
    visibility: true,
  },
  [DASHBOARD_CARD_TYPES.RECOMMENDATIONS]: {
    visibility: true,
  },
}

const DashboardSlice = createSlice({
  name: "DASHBOARD",
  initialState: {
    cardState: {
      ...JSON.parse(JSON.stringify(initialCardStates)),
    },
    currentGameId: "",
  },
  reducers: {
    // Setting current active Game Id for Dashboard
    setCurrentGameId: (state, action) => {
      state.currentGameId = action?.payload ?? ""
    },

    /**
     * Function to update dashboard card states
     * @param {*} action - `action.payload` to be like
     * @example
     * {
     *  source: "", // "OVERALL_PERFORMANCE" | "HISTORICAL_PERFORMANCE" | "GAME_STATUS" | "INDIVIDUAL_PERFORMANCE" | "RECOMMENDATIONS"
     *  states: {
     *    key: "", // "filters" | "searchText" | "visibility"
     *    data: {}, // Object
     *   }
     *
     * }
     * `
     */
    setDasboardCardStates: (state, action) => {
      const source = action?.payload.source
      const data = {
        [action?.payload.states.key]: action?.payload.states.data,
      }
      Object.assign(state.cardState[source], data)
      // switch (source) {
      //   case DASHBOARD_CARD_TYPES.OVERALL_PERFORMANCE:
      //   case DASHBOARD_CARD_TYPES.HISTORICAL_PERFORMANCE:
      //   case DASHBOARD_CARD_TYPES.GAME_STATUS:
      //   case DASHBOARD_CARD_TYPES.INDIVIDUAL_PERFORMANCE:
      //   case DASHBOARD_CARD_TYPES.RECOMMENDATIONS:
      //   default:
      //     break
      // }
    },

    setDashboardCardVisibility: (state, action) => {
      const viewSettings = action?.payload
      if (typeof viewSettings === "object") {
        Object.keys(viewSettings).forEach((cardName) => {
          Object.keys(viewSettings[cardName]).forEach((keyNode) => {
            if (keyNode === "visibility") {
              state.cardState[cardName].visibility = Object.hasOwn(viewSettings[cardName], "isVisible") ? viewSettings[cardName].isVisible : true
            } else {
              state.cardState[cardName][keyNode] = viewSettings[cardName][keyNode]
            }
          })
        })
      }
    },
  },
})

export const DashboardActions = DashboardSlice.actions
export default DashboardSlice
